import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'

import styles from './DetailBox.module.sass'

const DetailBox = (props) => {
	const { title, subTitle, text, value, className } = props

	return (
		<HStack className={`${styles['root'] || ''} ${className || ''}`}>
			<VStack>
				<HStack gap='xsmall'>
					<h5>{title}</h5>
					{subTitle ? <small>{subTitle}</small> : null}
				</HStack>
				<small>{text}</small>
			</VStack>
			<small className={styles['detail']}>{value}</small>
		</HStack>
	)
}

export default DetailBox
